<template>
    <div>
        <div class="p-col-10 p-mx-auto p-grid p-mt-1">
            <div class="p-col-12 p-md-4 box">
                <h3>
                    App Version Codes
                    <Button icon="pi pi-refresh" @click="loadChartDeviceAppVersions()" class="p-button p-button-sm p-button-outlined"
                        :disabled="charts.deviceAppVersions.isLoading" style="float:right" />
                </h3>
                <span v-if="charts.deviceAppVersions.isLoading">Loading...</span>
                
                <div class="p-grid p-text-center"
                    v-if="!charts.deviceAppVersions.isLoading && (charts.deviceAppVersions.labels !== null && charts.deviceAppVersions.labels.length > 0)"
                    style="width:100%">
                        <Chart class="p-mx-auto" type="pie" :data="charts.deviceAppVersions" :options="charts.chartOptions" />
                        
                        <table class="p-mt-4" style="width:100%;">
                            <tr>
                                <td><b>Version Code</b></td>
                                <td><b>Device Count</b></td>
                            </tr>
                            <tr v-for="(item, index) of charts.deviceAppVersions.labels" :key="index">
                                <td>{{item}}</td>
                                <td>{{formatNumber(charts.deviceAppVersions.datasets[0].data[index])}}</td>
                            </tr>
                            <tr>
                                <td><b>Total</b></td>
                                <td><b>{{formatNumber(charts.deviceAppVersions.datasets[0].data.reduce((sum, current) => sum + current, 0))}}</b></td>
                            </tr>
                        </table>
                </div>
                <span v-else-if="!charts.deviceAppVersions.isLoading">No data available</span>
            </div>
            <div class="p-col-12 p-md-8">
                <div class="p-grid">
                    <div class="p-col-12 p-md-6 box">
                        <h3>
                            New Install Devices Summary
                            <Button icon="pi pi-refresh" @click="loadDevicesSummaries()" class="p-button p-button-sm p-button-outlined"
                                :disabled="charts.devicesSummaries.isLoading" style="float:right" />
                        </h3>
                        <span v-if="charts.devicesSummaries.isLoading">Loading...</span>

                        <div class=""
                            v-if="!charts.devicesSummaries.isLoading && (charts.devicesSummaries.labels !== null && charts.devicesSummaries.labels.length > 0)"
                            style="width:100%">
                            <Chart type="bar" :data="charts.devicesSummaries" :options="charts.stackedOptions" />
                        </div>
                        <span v-else-if="!charts.devicesSummaries.isLoading">No data available</span>
                    </div>
                    <div class="p-col-12 p-md-6 box">
                        <h3>
                            Event Notification Summary
                            <Button icon="pi pi-refresh" @click="loadEventNotificationSummaries()" class="p-button p-button-sm p-button-outlined"
                                :disabled="charts.eventNotificationSummaries.isLoading" style="float:right" />
                        </h3>
                        <span v-if="charts.eventNotificationSummaries.isLoading">Loading...</span>

                        <div class=""
                            v-if="!charts.eventNotificationSummaries.isLoading && (charts.eventNotificationSummaries.labels !== null && charts.eventNotificationSummaries.labels.length > 0)"
                            style="width:100%">
                            <Chart type="bar" :data="charts.eventNotificationSummaries" :options="charts.stackedOptions" />
                        </div>
                        <span v-else-if="!charts.eventNotificationSummaries.isLoading">No data available</span>
                    </div>
                    <div class="p-col-12 p-md-12">
                        <h3>
                            Tracked Live Events
                            <Button icon="pi pi-refresh" @click="loadTrackingLiveEvents()" class="p-button p-button-sm p-button-outlined"
                                :disabled="charts.trackingEventSummaries.isLoading" style="float:right" />
                        </h3>
                        <span v-if="charts.trackingEventSummaries.isLoading">Loading...</span>

                        <div class=""
                            v-if="!charts.trackingEventSummaries.isLoading && (charts.trackingEventSummaries.items !== null && charts.trackingEventSummaries.items !== undefined && charts.trackingEventSummaries.items.length > 0)"
                            style="width:100%">
                            <div v-for="(event) in charts.trackingEventSummaries.items" :key="event.ssEventId" class="p-p-2 p-mb-1 box">
                                {{event.startTime}} {{event.ssHomeTeamName}} - {{event.ssAwayTeamName}} ({{formatNumber(event.subscribedDeviceCount)}})
                            </div>
                        </div>
                        <span v-else-if="!charts.trackingEventSummaries.isLoading">Currently no tracked events.</span>
                    </div>
                </div>
            </div>
        </div>

    </div>
</template>

<style scoped>
</style>

<script>
import axios from "axios";
import Chart from 'primevue/chart';
import Button from 'primevue/button';

let SpringApi;

export default {
    name: 'Dashboard',
    components: {
        Chart, Button
    },
    data() {
        return {
            visibleLeft: false,
            isMenuLoaded: false,
            panelMenuItems: [],
            charts: {
                chartOptions: {
                    borderWidth: 0,
                    legend: {
                        labels: {
                            color: '#FF0000'
                        },
                        display: 'none',
                        
                    }
                },
                stackedOptions: {
                    plugins: {
                        tooltips: {
                            mode: 'index',
                            intersect: false
                        },
                        legend: {
                            labels: {
                                color: '#F0F0F0'
                            }
                        }
                    },
                    scales: {
                        x: {
                            stacked: true,
                            ticks: {
                                color: '#F0F0F0'
                            },
                            grid: {
                                color: '#29323d'
                            }
                        },
                        y: {
                            stacked: true,
                            ticks: {
                                color: '#F0F0F0'
                            },
                            grid: {
                                color: '#29323d'
                            }
                        }
                    }
                },
                deviceAppVersions: {
                    labels: [],
                    datasets: [],
                    isLoading: false,
                },
                devicesSummaries: {
                    labels: [],
                    datasets: [],
                    isLoading: false,
                },
                eventNotificationSummaries: {
                    labels: [],
                    datasets: [],
                    isLoading: false,
                },
                trackingEventSummaries: {
                    items: [],
                    isLoading: false,
                },
            }
        }
    },
    beforeMount() {
        SpringApi = axios.create({
            baseURL : process.env.VUE_APP_SPRING_API_URL,
            headers: {
                'Authorization': 'Bearer ' + this.$cookies.get('token')
            }
        });

        var page = {
            title: "Dashboard"
        }
        this.$emit('pageLoaded', page)
    },
    mounted() {
        this.loadCharts()
    },
    methods: {
        loadCharts() {
            this.loadChartDeviceAppVersions()
            this.loadDevicesSummaries()
            this.loadEventNotificationSummaries()
            this.loadTrackingLiveEvents()
        },
        async loadChartDeviceAppVersions() {
            this.charts.deviceAppVersions.isLoading = true;
            let response = await SpringApi.get('/dashboard/app-version-code-counts')

            this.charts.deviceAppVersions.labels = response.data.map(item => item.appVersionCode);
            let dataset = {
                data: response.data.map(item => item.deviceCount),
                backgroundColor: this.generateHexColors(this.charts.deviceAppVersions.labels.length, 30),
                hoverBackgroundColor: this.generateHexColors(this.charts.deviceAppVersions.labels.length, 30),
            }

            this.charts.deviceAppVersions.datasets = [dataset];
            this.charts.deviceAppVersions.isLoading = false;
        },
        async loadDevicesSummaries() {
            this.charts.devicesSummaries.isLoading = true;
            let response = await SpringApi.get('/dashboard/devices-summaries')

            let datasets = response.data.datasets

            if (datasets !== null && datasets !== undefined) {
                let labels = response.data.labels
                
                datasets.forEach((dataset, index) => {
                    dataset.type = 'bar',
                    dataset.backgroundColor = this.generateHexColors(1, (dataset.label))
                })
    
                this.charts.devicesSummaries.labels = labels
                this.charts.devicesSummaries.datasets = datasets
            }

            this.charts.devicesSummaries.isLoading = false;
        },
        async loadEventNotificationSummaries() {
            this.charts.eventNotificationSummaries.isLoading = true;
            let response = await SpringApi.get('/dashboard/event-notification-count-summaries')

            let datasets = response.data.datasets

            if (datasets !== null && datasets !== undefined) {
                let labels = response.data.labels
    
                datasets.forEach((dataset, index) => {
                    dataset.type = 'bar',
                    dataset.backgroundColor = this.generateHexColors(1, (index + 6))
                })
    
                this.charts.eventNotificationSummaries.labels = labels
                this.charts.eventNotificationSummaries.datasets = datasets
            }

            this.charts.eventNotificationSummaries.isLoading = false;
        },
        async loadTrackingLiveEvents() {
            this.charts.trackingEventSummaries.isLoading = true;
            let response = await SpringApi.get('/dashboard/tracking-event-summaries')

            this.charts.trackingEventSummaries.items = response.data;
            this.charts.trackingEventSummaries.isLoading = false;
        },
        formatNumber(number) {
            return new Intl.NumberFormat('de-DE').format(number);
        },
        generateHexColors(numColors, seed) {
            const colors = [];
            const seededRandom = this.seedRandom(seed);
            for (let i = 0; i < numColors; i++) {
                colors.push(this.getRandomHexColor(seededRandom));
            }
            return colors;
        },
        seedRandom(seed) {
            let s = seed;
            return function() {
                s = Math.sin(s) * 10000;
                return s - Math.floor(s);
            };
        },
        getRandomHexColor(randomFunc) {
            const letters = '0123456789ABCDEF';
            let color = '#';
            for (let i = 0; i < 6; i++) {
                color += letters[Math.floor(randomFunc() * 16)];
            }
            return color;
        }
    }
}
</script>